import React from "react";
import { FontIcon } from "@fluentui/react";
import { AttachmentType } from "../../../../types/messages";
import {
  WORD_ICON_COLOR,
  EXCEL_ICON_COLOR,
  POWER_POINT_ICON_COLOR,
  OUTLOOK_ICON_COLOR,
  PDF_ICON_COLOR,
  IMAGE_ICON_COLOR,
} from "../../../../config/colors";

type Props = {
  type: AttachmentType;
  size: number;
};

const AttachmentIcon: React.FC<Props> = (props) => {
  const { type, size } = props;

  switch (type) {
    case "Word":
      return (
        <FontIcon
          aria-label="Word Document"
          iconName="WordDocument"
          style={{ color: WORD_ICON_COLOR, fontSize: size }}
        />
      );
    case "Pdf":
      return <FontIcon aria-label="PDF" iconName="PDF" style={{ color: PDF_ICON_COLOR, fontSize: size }} />;
    case "Email":
      return <FontIcon aria-label="Mail" iconName="Mail" style={{ color: OUTLOOK_ICON_COLOR, fontSize: size }} />;
    case "Excel":
      return (
        <FontIcon
          aria-label="Excel Document"
          iconName="ExcelDocument"
          style={{ color: EXCEL_ICON_COLOR, fontSize: size }}
        />
      );
    case "PowerPoint":
      return (
        <FontIcon
          aria-label="Power Point Document"
          iconName="PowerPointDocument"
          style={{ color: POWER_POINT_ICON_COLOR, fontSize: size }}
        />
      );
    case "Image":
      return (
        <FontIcon
          aria-label="Image Document"
          iconName="FileImage"
          style={{ color: IMAGE_ICON_COLOR, fontSize: size }}
        />
      );

    default:
      return <FontIcon aria-label="Document" iconName="Document" style={{ fontSize: size }} />;
  }

  return <div></div>;
};

export default AttachmentIcon;
